export default __webpack_public_path__ + "static/media/deleteCompany.716e33c0.svg";